import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-teal d-flex w-100 align-center px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Get connected with us on social networks!", -1)
const _hoisted_3 = { class: "px-4 py-2 bg-black text-center w-100" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Carta moz Lite", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: "teal-darken-4",
        image: "https://picsum.photos/1920/1080?random"
      }, {
        image: _withCtx(() => [
          _createVNode(_component_v_img, { gradient: "to top right, rgba(19,84,122,.8), rgba(128,208,199,.8)" })
        ]),
        prepend: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, { to: "/" })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_title, null, {
            default: _withCtx(() => [
              _createTextVNode("Carta Moz")
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, { class: "d-flex flex-column" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode(_component_v_spacer),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon) => {
              return (_openBlock(), _createBlock(_component_v_btn, {
                key: icon,
                icon: icon,
                class: "mx-4",
                size: "small",
                variant: "plain"
              }, null, 8, ["icon"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(new Date().getFullYear()) + " — ", 1),
            _hoisted_4
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}